import { storage } from 'src/utils/storage';

import type { LoginResponse } from 'src/features/auth/types';
import { queryClient } from 'src/lib/react-query';
import { USER_QUERY_KEY } from 'src/features/auth/utils/constants';
import { jwtDecode } from 'jwt-decode';
import { Token } from 'src/features/auth/types';

function handleUserResponse(data: LoginResponse) {
    const { user, ...token } = data;
    storage.setToken(token);
    queryClient.setQueryData([USER_QUERY_KEY], jwtDecode<Token>(token.access));
    return user;
}

export { handleUserResponse };
